export default __webpack_public_path__ + "static/air_compressor_w.c4e1300441fa9aa6c02c81b826d6680c.png";